import { render } from "./leydetalleconsultageneral.vue?vue&type=template&id=8b2b6f42"
import script from "./leydetalleconsultageneral.vue?vue&type=script&lang=js"
export * from "./leydetalleconsultageneral.vue?vue&type=script&lang=js"

import "./leydetalleconsultageneral.vue?vue&type=style&index=0&id=8b2b6f42&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__